import React, { useState } from "react"
import { isEmail } from 'validator'

import LoginForm from './LoginForm'
import UserDataForm from './UserDataForm'
import { API_GATEWAY_URL, LOGIN_ERROR_MESSAGE_CREDENTIALS, LOGIN_ERROR_MESSAGE_GENERIC, SUBMISSION_ERROR_MESSAGE_GENERIC, SUBMISSION_ERROR_MESSAGE_ADDRESS_PO_BOX, SUBMISSION_ERROR_MESSAGE_MAX_SHIPMENTS } from '../constants'
import { getDatepickerDateOptions } from '../helpers/datepickerhelpers';
import { addressIsPOBox } from '../helpers/inputHelpers';

class AppForm extends React.Component {
    constructor(props) {
        super(props);
        this.onLoginFormSubmit = this.onLoginFormSubmit.bind(this);
        this.onUserFormSubmit = this.onUserFormSubmit.bind(this);
        this.setLoginErrorMessage = this.setLoginErrorMessage.bind(this);
        this.clearLoginErrorMessage = this.clearLoginErrorMessage.bind(this);
        this.setUpdateUserErrorMessage = this.setUpdateUserErrorMessage.bind(this);
        this.clearUpdateUserErrorMessage = this.clearUpdateUserErrorMessage.bind(this);
        this.handleLoginInput = this.handleLoginInput.bind(this);
        this.handleUserDataInput = this.handleUserDataInput.bind(this);
        this.handleUserDataShippingDate = this.handleUserDataShippingDate.bind(this);
        this.renderMainView = this.renderMainView.bind(this);

        const datepickerOptions = getDatepickerDateOptions();

        this.state = {
            userLogin: {},
            userData: {},
            userId: "", // Store user ID and password separate from userLogin to fix issue with Lastpass overwriting password field on login submit
            password: "",
            shippingDateOptions: datepickerOptions,
            blackoutDates: [], // Add blackout dates to state
            loginFormSubmitSuccessful: false,
            userFormSubmitSuccessful: false,
            loginErrorMessage: "",
            updateUserErrorMessage: ""
            // errors: {},
        }
    }

    handleLoginInput(event) {
        const userLogin = this.state.userLogin;
        userLogin[event.target.name] = event.target.value
        this.setState({userLogin: userLogin})
    }

    handleUserDataInput(event) {
        const userData = this.state.userData;
        userData[event.target.name] = event.target.value
        this.setState({userData: userData})
    }

    // TODO: yuck
    handleUserDataShippingDate(shippingDate) {
        const userData = this.state.userData;
        userData["shipping_date"] = shippingDate
        this.setState({userData: userData})

        if (shippingDate) {
            this.setState({shippingDateOptions: getDatepickerDateOptions(shippingDate)})
        }
    }

    setLoginErrorMessage(message) {
        this.setState({loginErrorMessage: message})
    }

    clearLoginErrorMessage() {
        this.setState({loginErrorMessage: ""})
    }

    setUpdateUserErrorMessage(message) {
        this.setState({updateUserErrorMessage: message})
    }

    clearUpdateUserErrorMessage() {
        this.setState({updateUserErrorMessage: ""})
    }

    onLoginFormSubmit(event) {
        event.preventDefault();
        this.clearLoginErrorMessage();

        const userId = this.state.userLogin.user_id;
        const password = this.state.userLogin.password;

        // TODO: validation?
        console.log(userId, password);
        if (!userId) {
            console.log("User ID is blank");
            return
        }
        if (!password) {
            console.log("Password is blank");
            return
        }

        fetch(`${API_GATEWAY_URL}/dev/login`, {
            method: 'POST',
            body: JSON.stringify({
                user_id: userId,
                password: password
            })
        })
            .then((response) => {
                let json = response.json();
                if (!response.ok) {
                    console.log("Login request failed")
                    console.log(response)
                    if (response.status === 401) {
                        this.setLoginErrorMessage(LOGIN_ERROR_MESSAGE_CREDENTIALS)
                    } else {
                        this.setLoginErrorMessage(LOGIN_ERROR_MESSAGE_GENERIC)
                    }

                    // TODO: how to exit out the right way?
                    throw Error();
                } else {
                    return json;
                }
            })
            .then(
                (response) => {
                    console.log(response)
                    if (!response.user) {
                        console.log("User data not included in response")
                        console.log(response);

                        this.setLoginErrorMessage(LOGIN_ERROR_MESSAGE_GENERIC)
                        return
                    }

                    const newState = {
                        userData: response.user,
                        loginFormSubmitSuccessful: true,
                        userId: userId,
                        password: password,
                        blackoutDates: response.blackout_dates || [] // Store blackout dates from response
                    }

                    if (response.user.shipping_date) {
                        newState.shippingDateOptions = getDatepickerDateOptions(response.user.shipping_date);
                    }

                    this.setState(newState);
                },
                (error) => {
                    console.log(error)
                    if (!this.state.loginErrorMessage) {
                        this.setLoginErrorMessage(LOGIN_ERROR_MESSAGE_GENERIC)
                    }
                }
            );
    }

    onUserFormSubmit(event) {
        event.preventDefault();
        this.clearUpdateUserErrorMessage()
        console.log('User Form submitted - current state:', this.state);
        const data = this.state.userData;
        const userId = this.state.userId;
        const password = this.state.password;

        const request_body = JSON.stringify({
            user_id: userId,
            password: password,
            update_request_data: data
        });

        // Input Validation
        const { shipping_address } = data;
        if (addressIsPOBox(shipping_address)) {
            this.setUpdateUserErrorMessage(SUBMISSION_ERROR_MESSAGE_ADDRESS_PO_BOX)
            return
        }

        fetch(`${API_GATEWAY_URL}/dev/updateUser`, {
            method: 'POST',
            body: request_body
        })
            .then((response) => {
                if (!response.ok) {
                    console.log("Update User request failed")
                    console.log(response)

                    // TODO: better way than using 416 status for "Max shipments for date exceeded"
                    if (response.status === 416) {
                        this.setUpdateUserErrorMessage(SUBMISSION_ERROR_MESSAGE_MAX_SHIPMENTS);
                    } else {
                        this.setUpdateUserErrorMessage(SUBMISSION_ERROR_MESSAGE_GENERIC)
                    }

                    // TODO: how to exit out the right way?
                    throw Error();
                } else {
                    return response.json();
                }
            })
            .then(
                (result) => {
                    console.log('Update successful')
                    console.log('updateUser API response:', result)
                    console.log('State before update:', this.state)
                    this.setState({
                        userFormSubmitSuccessful: true,
                        userData: { ...this.state.userData }
                    }, () => {
                        // Scroll to top after state update
                        window.scrollTo(0, 0);
                        console.log('State after update:', this.state)
                    })
                },
                (error) => {
                    console.log(error)
                    if (!this.state.updateUserErrorMessage) {
                        this.setUpdateUserErrorMessage(SUBMISSION_ERROR_MESSAGE_GENERIC)
                    }
                }
            );
    }

    renderUserDataForm(userData) {
        if (Object.keys(userData).length === 0) {
            return <div></div>
        }

        return <UserDataForm
                    onSubmit={this.onUserFormSubmit}
                    handleInput={this.handleUserDataInput}
                    handleShippingDateChange={this.handleUserDataShippingDate}
                    shippingDateOptions={this.state.shippingDateOptions}
                    blackoutDates={this.state.blackoutDates}
                    errorMessage={this.state.updateUserErrorMessage}
                    {...userData}
                />
    }

    renderConfirmationScreen() {
        return (
            <div>
                <div className="row"></div>
                <h5>Your information has been saved. Thank you!</h5>
            </div>
        )
    }

    renderSiteDisabledScreen() {
        return (
            <div>
                <div className="row"></div>
                <h5>SITE CLOSED, PLEASE CONTACT UAN DIRECTLY IF YOU STILL NEED TO SCHEDULE YOUR DELIVERY.</h5>
                {/* <h5>Temporarily Offline - Check Back Tomorrow.</h5> */}
            </div>
        )
    }

    renderMainView() {
        return (
            <div>
                <LoginForm onSubmit={this.onLoginFormSubmit} handleInput={this.handleLoginInput} errorMessage={this.state.loginErrorMessage} />
                {
                    this.renderUserDataForm(this.state.userData)
                }
            </div>
        )
    }

    render() {
        const userFormSubmitSuccessful = this.state.userFormSubmitSuccessful;
        console.log('Render - userFormSubmitSuccessful:', userFormSubmitSuccessful);
        console.log('Render - current state:', this.state);

        let mainView;

        // Uncomment below to disable site
        mainView = this.renderSiteDisabledScreen();

        // Uncomment below to enable site
        // if (userFormSubmitSuccessful) {
        //     console.log('Rendering confirmation screen');
        //     mainView = this.renderConfirmationScreen();
        // } else {
        //     console.log('Rendering main view');
        //     mainView = this.renderMainView();
        // }

        return (
            <div>
                {mainView}
            </div>
        );
    }
}

export default AppForm;
